/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ company: NonNullable<unknown> }} Signup_Invitation_Banner_GenericInputs */

const es_co2_signup_invitation_banner_generic = /** @type {(inputs: Signup_Invitation_Banner_GenericInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fuiste invitado a unirte a ${i?.company}.`)
};

/**

* @param {Signup_Invitation_Banner_GenericInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_invitation_banner_generic = /** @type {((inputs: Signup_Invitation_Banner_GenericInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Invitation_Banner_GenericInputs, { locale?: "es-CO" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_invitation_banner_generic(inputs)
});